import axios from "axios";
const URL = process.env.VUE_APP_API;

export default {
  login(payload) {
    return axios.post(`${URL}/tokens`, { ...payload }).then((res) => {
      return res.data;
    });
  },
  signup(payload) {
    return axios.post(`${URL}/signup`, { ...payload }).then((res) => {
      return res.data;
    });
  },
  confirm(token, payload) {
    return axios
      .post(`${URL}/confirmation?confirmation_token=${token}`, { ...payload })
      .then((res) => {
        return res.data;
      });
  },
  forgotPassword(email) {
    return axios
      .get(`${URL}/password_reset?email=${email}`)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
  newPassword(password, token) {
    return axios
      .post(`${URL}/password_reset?reset_password_token=${token}`, {
        password: password,
      })
      .then((res) => {
        return res.data;
      });
  },
  getUsers() {
    return axios.get(`${URL}/users`).then((res) => {
      return res.data;
    });
  },
  getUser(id) {
    return axios.get(`${URL}/users/${id}`).then((res) => {
      return res.data;
    });
  },
  getCompany(id) {
    return axios.get(`${URL}/companies/${id}`).then((res) => {
      return res.data;
    });
  },
  getCompanies() {
    return axios.get(`${URL}/companies`).then((res) => {
      return res.data;
    });
  },
  getCompanyContract(id) {
    return axios.get(`${URL}/companies/${id}/contracts`).then((res) => {
      return res.data;
    });
  },
  updateContract(id, payload) {
    return axios.patch(`${URL}/contracts/${id}`, { ...payload }).then((res) => {
      return res.data;
    });
  },
  createContract(payload) {
    return axios
      .post(`${URL}/contracts`, { ...payload })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
  createCompany(payload) {
    return axios
      .post(`${URL}/companies`, { ...payload })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
  createBundle(payload) {
    return axios
      .post(`${URL}/bundles`, { ...payload })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
  deleteCompany(id) {
    return axios.delete(`${URL}/companies/${id}`).then((res) => {
      return res.data;
    });
  },
  deleteBundle(id) {
    return axios.delete(`${URL}/bundles/${id}`).then((res) => {
      return res.data;
    });
  },
  getCompanyUsers(id) {
    return axios
      .get(`${URL}/companies/${id}/users/?role=company_admin,company_member`)
      .then((res) => {
        return res.data;
      });
  },
  updateUser(id, payload) {
    return axios.patch(`${URL}/users/${id}`, { ...payload }).then((res) => {
      return res.data;
    });
  },
  postUser(payload) {
    return axios
      .post(`${URL}/users`, { ...payload })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
  deleteUser(id) {
    return axios.delete(`${URL}/users/${id}`).then((res) => {
      return res.data;
    });
  },
};
